import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { StreamAction } from '../stream.action';
import { StreamTranslator } from '../stream.translator';

type IDependencies = IClientApiDependencySegment;

export const loadStreamEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(StreamAction.load.started),
  switchMap((params) => {
    return dependencies.api.getStream(params).pipe(
      mergeMap((response) => {
        const result = StreamTranslator.fromApi(response);

        return [
          StreamAction.load.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          StreamAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
